export default __webpack_public_path__ + "static/media/ornaments.1de7ace9.png";